import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '@app/api/api-services/crud.service.base';
import {
  SiteSkillBaseApiModel,
  SiteSkillHeadingApiModel,
  ProgramSkillHeadingApiModel,
  ProgramSettingsUsageInfoApiModel
} from '@app/api/api-models';

@Injectable()
export class ProgramSkillHeadingsService extends CrudService<
  ProgramSkillHeadingApiModel,
  SiteSkillBaseApiModel,
  number
> {
  public apiUrl = 'program-skill-headings';

  public getUsageInfo(id: number): Observable<ProgramSettingsUsageInfoApiModel> {
    return this.http.get<ProgramSettingsUsageInfoApiModel>(`${this.apiUrl}/${id}/usage-info`);
  }

  public getUnused(): Observable<SiteSkillHeadingApiModel[]> {
    return this.http.get<SiteSkillHeadingApiModel[]>(`${this.apiUrl}/unused`);
  }

  public addBatch(ids: number[]): Observable<number[]> {
    return this.http.post<number[]>(`${this.apiUrl}/add-batch`, ids);
  }

  public getExistingSkill(payload: ProgramSkillHeadingApiModel): Observable<ProgramSkillHeadingApiModel> {
    return this.http.post<ProgramSkillHeadingApiModel>(`${this.apiUrl}/existing`, payload);
  }
}
